import {
    USER_ACHIEVEMENTS_PENDING,
    USER_ACHIEVEMENTS_DOWNLOADED,
    USER_ACHIEVEMENTS_FAILED,
} from './types';
import APIService from '../../services/api';
import { handleError } from '../infos/actions';
import { ACHIEVEMENTS_FAILED } from '../achievements/types';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
export const userAchievementsPendingAction = () => {
    return {
        type: USER_ACHIEVEMENTS_PENDING,
    };
};

export const userAchievementsDownloadedAction = (userAchievements) => {
    return {
        type: USER_ACHIEVEMENTS_DOWNLOADED,
        payload: userAchievements,
    };
};

export const userAchievementsFailedAction = (error) => {
    return {
        type: USER_ACHIEVEMENTS_FAILED,
        payload: error,
    };
};

export function getUserAchievements(app, currentLang, format, limit, achievementId) {
    return function (dispatch) {
        dispatch(userAchievementsPendingAction());
        return APIService
            .getUserAchievements(app, cookies.get('token'), currentLang, format, false, limit, achievementId)
            .then(userAchievements => {
                dispatch(userAchievementsDownloadedAction(userAchievements));
            })
            .catch((error) => {
                dispatch(handleError(error, ACHIEVEMENTS_FAILED));
                dispatch(userAchievementsFailedAction(error));
            });
    };
}



// WEBPACK FOOTER //
// src/store/userachievements/actions.js